import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusPill } from "@/components/StatusPill";
import { Plus, Calendar, Clock } from "lucide-react";

export default function FacilityRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    api.get("/requests").then((r) => setRequests(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="facility-requests">
      <div className="flex items-end justify-between">
        <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>My Requests</h1>
        <Link to="/facility/requests/new">
          <Button className="bg-brand-navy hover:bg-brand-blue" data-testid="facility-requests-new-btn"><Plus className="w-4 h-4 mr-1" />New request</Button>
        </Link>
      </div>
      <div className="grid gap-3">
        {requests.map((r) => (
          <Card key={r.id} className="hover:border-brand-teal transition-colors" data-testid={`req-row-${r.id}`}>
            <CardContent className="p-5 grid grid-cols-12 gap-4 items-center">
              <div className="col-span-12 md:col-span-4">
                <div className="font-bold text-slate-900 text-lg">{r.position} × {r.count}</div>
                <div className="text-xs text-slate-500 mt-1">{r.department || "—"} · {r.shift_type}</div>
              </div>
              <div className="col-span-6 md:col-span-3 text-sm text-slate-600 space-y-1">
                <div className="flex items-center gap-2"><Calendar className="w-3 h-3" /> {r.shift_date}</div>
                <div className="flex items-center gap-2"><Clock className="w-3 h-3" /> {r.start_time} – {r.end_time}</div>
              </div>
              <div className="col-span-6 md:col-span-2 text-sm">
                <span className={`font-semibold ${r.urgency === "emergency" ? "text-red-600" : r.urgency === "urgent" ? "text-amber-600" : "text-slate-700"}`}>
                  {r.urgency?.toUpperCase()}
                </span>
              </div>
              <div className="col-span-12 md:col-span-3 flex md:justify-end">
                <StatusPill status={r.status} />
              </div>
            </CardContent>
          </Card>
        ))}
        {requests.length === 0 && (
          <div className="text-center py-16 text-slate-500">No requests yet. <Link to="/facility/requests/new" className="text-brand-teal font-semibold">Create your first request</Link></div>
        )}
      </div>
    </div>
  );
}
